import React, { Component } from 'react'
import * as PropTypes from 'prop-types'
import { PermissionShape } from '../../../../prop-types'
import { permissionOperations } from '../../../../state/ducks/permissions'
import { connect } from 'react-redux'
import { BaseFormWizard } from '../../../../assets/js/base_form_wizard'
import { AppUI } from '../../../../assets/js/app'
import { PermissionDataForm } from '../permission-data-form'
import { PermissionGroupsForm } from '../permission-groups-form'

class PermissionWizardForm extends Component {
  constructor (props) {
    super(props)

    // state
    this.state = {
      permission: {
        groups: []
      }
    }

    // handlers
    this.onPermissionDataChange = this.onPermissionDataChange.bind(this)
    this.onPermissionGroupsChange = this.onPermissionGroupsChange.bind(this)
    this.sendData = this.sendData.bind(this)
    AppUI.initHelpers(['highlightjs'])
  }

  componentDidMount () {
    BaseFormWizard.init()
  }

  UNSAFE_componentWillReceiveProps (nextProps, nextContext) {
    if (nextProps.permission && 'id' in nextProps.permission) {
      this.setState({ permission: nextProps.permission })
    }
  }

  onPermissionDataChange (name, value) {
    const permission = this.state.permission
    permission[name] = value
    this.setState({
      permission
    })
  }

  onPermissionGroupsChange (groups) {
    const permission = this.state.permission
    permission.groups = JSON.parse(JSON.stringify(groups))
    this.setState({
      permission: JSON.parse(JSON.stringify(permission))
    })
  }

  sendData () {
    if (!this.props.isEditor) {
      this.props.savePermission(this.state.permission)
    } else {
      this.props.updatePermission(this.state.permission.id, this.state.permission)
    }
  }

  render () {
    return (
            <>
                <div className="content content-boxed">
                    <div className={' block block-themed block-opt-refresh-icon7 ' + (this.props.isLoading ? ' block-opt-refresh ' : '')}>
                        <div className="block-content">
                            {/* Simple Progress Wizard (.js-wizard-simple class is initialized in js/pages/base_forms_wizard.js) */}
                            {/* For more examples you can check out http://vadimg.com/twitter-bootstrap-wizard-example/ */}
                            <div className="js-wizard-simple block">
                                {/* Steps Progress */}
                                <div className="block-content block-content-mini block-content-full border-b">
                                    <div className="wizard-progress progress active remove-margin-b">
                                        <div className="progress-bar progress-bar-primary progress-bar-striped"
                                             role="progressbar" aria-valuenow="100" aria-valuemin="0"
                                             aria-valuemax="100"
                                             style={{ width: '0' }}>
                                        </div>
                                    </div>
                                </div>
                                {/* END Steps Progress */}

                                {/* Step Tabs */}
                                <ul className="nav nav-tabs nav-tabs-alt nav-justified">
                                    <li className="active">
                                        <a href="#simple-progress-step1" data-toggle="tab">1. Permission Data</a>
                                    </li>
                                    <li>
                                        <a href="#simple-progress-step2" data-toggle="tab">2. Groups</a>
                                    </li>
                                </ul>
                                {/* END Step Tabs */}

                                {/* Form */}
                                <form className="form-horizontal" action="javascript:void(0)">
                                    {/* Steps Content */}
                                    <div className="block-content tab-content" style={{ minHeight: '300px' }}>
                                        {/* Step 1 */}
                                        <div className="tab-pane fade fade-right in push-30-t push-50 active"
                                             id="simple-progress-step1">
                                            <PermissionDataForm
                                                permission={this.state.permission}
                                                onChange={this.onPermissionDataChange}
                                            />
                                        </div>
                                        {/* END Step 1 */}

                                        {/* Step 2 */}
                                        <div className="tab-pane fade fade-right in push-30-t push-50"
                                             id="simple-progress-step2">
                                            <PermissionGroupsForm
                                                added_groups={this.state.permission.groups}
                                                onChange={this.onPermissionGroupsChange}
                                            />
                                            {/* END Step 2 */}
                                        </div>
                                    </div>
                                    {/* END Steps Content */}

                                    {/* Steps Navigation */}
                                    <div className="block-content block-content-mini block-content-full border-t">
                                        <div className="row">
                                            {
                                                this.props.savePermissionErrorResponse.error
                                                  ? <div className="col-xs-12 text-danger text-center">
                                                        {JSON.stringify(this.props.savePermissionErrorResponse.error)}
                                                    </div>
                                                  : null
                                            }
                                            {
                                                this.props.updatePermissionErrorResponse.error
                                                  ? <div className="col-xs-12 text-danger text-center">
                                                        {JSON.stringify(this.props.updatePermissionErrorResponse.error)}
                                                    </div>
                                                  : null
                                            }
                                            <div className="col-xs-6">
                                                <button
                                                    className="wizard-prev btn btn-warning"
                                                    type="button"
                                                >
                                                    <i className="fa fa-arrow-circle-o-left"></i> Previous
                                                </button>
                                            </div>
                                            <div className="col-xs-6 text-right">
                                                <button
                                                    className="wizard-next btn btn-success"
                                                    type="button"
                                                >
                                                    Next <i className="fa fa-arrow-circle-o-right"></i>
                                                </button>
                                                <button
                                                    className="wizard-finish btn btn-primary"
                                                    type="button"
                                                    disabled={this.props.isLoading}
                                                    onClick={this.sendData}
                                                >
                                                    {
                                                        this.props.isLoading
                                                          ? <>
                                                                <i className="ml-1 fa fa-spinner fa-spin pull-right"></i>
                                                                <span>Submit</span>
                                                            </>
                                                          : <>
                                                                <i className="ml-1 si si-login pull-right"></i>
                                                                <span>Submit</span>
                                                            </>
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {/* END Steps Navigation */}
                                </form>
                                {/* END Form */}
                            </div>
                            {/* END Simple Progress Wizard */}
                            {/* <pre className="pre-sh push"> */}
                            {/*    <code className="json"> */}
                            {/*    {JSON.stringify(this.state.permission)} */}
                            {/*    </code> */}
                            {/* </pre> */}
                        </div>
                    </div>
                </div>
            </>
    )
  }
}

// Set propTypes
PermissionWizardForm.propTypes = {
  permission: PermissionShape,
  savePermissionErrorResponse: PropTypes.object,
  updatePermissionErrorResponse: PropTypes.object,
  isEditor: PropTypes.bool
}

// Set defaultProps
PermissionWizardForm.defaultProps = {
  permission: {},
  savePermissionErrorResponse: {},
  updatePermissionErrorResponse: {},
  isEditor: false
}

// mapStateToProps
const mapStateToProps = (state) => ({
  isLoading: state.permissions.savePermissionReducer.loading || state.permissions.updatePermissionReducer.loading,
  savePermissionErrorResponse: state.permissions.savePermissionReducer.error_data,
  updatePermissionErrorResponse: state.permissions.updatePermissionReducer.error_data
})

// mapStateToProps
const mapDispatchToProps = {
  savePermission: permissionOperations.save,
  updatePermission: permissionOperations.update
}

// Export Class
const _PermissionWizardForm = connect(mapStateToProps, mapDispatchToProps)(PermissionWizardForm)
export { _PermissionWizardForm as PermissionWizardForm }
